{
  "groups": {
    "dashboard": "Vue d'ensemble",
    "work": "Travail",
    "administration": "Administration",
    "people": "Personnel",
    "time-attendance": "Temps et présence",
    "payroll": "Paie",
    "reports": "Rapports",
    "setup": "Configuration",
    "operations": "Opérations",
    "expenses": "Dépenses et voyages",
    "talent": "Talents et performance",
    "portals": "Portails libre-service",
    "settings": "Paramètres"
  },
  "paths": {
    "hr": "RH Tableau de bord",
    "hr.attendance": "Présence et Congés",
    "hr.timesheet": "Timesheet",
    "hr.payroll": "Paie runs",
    "hr.dashboard": "RH Tableau de bord",
    "hr.leaves": "Congéss",
    "hr.ess": "Ess",
    "hr.mss": "Mss",
    "hr.setup": "Configuration",
    "hr.master-data": "Données de référence",
    "org.companies": "Sociétés",
    "work.approvals": "Boîte d'approbation",
    "pos.dashboard": "Tableau de bord",
    "pos.stores": "Magasins",
    "pos.products": "Produits",
    "pos.categories": "Catégories",
    "pos.brands": "Marques",
    "pos.units": "Units",
    "pos.tax-rules": "Tax Rules",
    "pos.store-products": "Magasins Produits",
    "pos.invoices": "Factures",
    "pos.inventory": "Inventaire",
    "pos.inventory.ledger": "Ledger",
    "pos.product-alerts": "Produits Alerts",
    "pos.suppliers": "Fournisseurs",
    "pos.customers": "Clients",
    "pos.discounts": "Remises",
    "pos.reports": "Rapports",
    "pos.terminal-reports": "Terminal Rapports",
    "pos": "PDV",
    "pos.held": "Held",
    "pos.shift": "Équipes",
    "pos.returns": "Returns",
    "pos.analytics": "Analytique",
    "pos.setup": "Configuration",
    "warehouse": "Entrepôt",
    "warehouse.operations": "Opérations",
    "warehouse.mobile": "Mobile",
    "warehouse.setup": "Configuration",
    "warehouse.picks": "Picks",
    "warehouse.transfers": "Transfers",
    "warehouse.cycle-counts": "Cycle Counts",
    "warehouse.waves": "Waves",
    "warehouse.dock": "Dock",
    "warehouse.cross-dock": "Cross Dock",
    "warehouse.labor": "Labor",
    "procurement": "Achats",
    "procurement.purchase-requests": "Achat Requests",
    "procurement.rfqs": "Rfqs",
    "procurement.quotations": "Quotations",
    "procurement.purchase-orders": "Achat Commandes",
    "procurement.goods-receipts": "Goods Receipts",
    "procurement.vendor-bills": "Vendor Bills",
    "procurement.approvals": "Approbations",
    "procurement.reports": "Rapports",
    "procurement.setup": "Configuration",
    "procurement.contracts": "Contracts",
    "procurement.catalogs": "Catalogs",
    "crm": "CRM",
    "crm.leads": "Prospects",
    "crm.contacts": "Contacts",
    "crm.companies": "Sociétés",
    "crm.deals": "Affaires",
    "crm.pipelines": "Pipelines",
    "crm.followups": "Followups",
    "crm.tasks": "Tâches",
    "crm.campaigns": "Campagnes",
    "crm.analytics": "Analytique",
    "crm.reports": "Rapports",
    "crm.setup": "Configuration",
    "lead-gen": "Lead Generation",
    "lead-gen.forms": "Forms",
    "lead-gen.landing-pages": "Landing Pages",
    "lead-gen.campaigns": "Campagnes",
    "lead-gen.visitor-tracking": "Visitor Tracking",
    "lead-gen.scoring": "Scoring",
    "lead-gen.routing": "Routing",
    "lead-gen.ab-tests": "Ab Tests",
    "lead-gen.webhooks": "Webhooks",
    "lead-gen.enrichment": "Enrichment",
    "lead-gen.consent": "Consent",
    "lead-gen.reports": "Rapports",
    "lead-gen.sources": "Sources",
    "marketing": "Marketing",
    "marketing.campaigns": "Campagnes",
    "marketing.segments": "Segments",
    "marketing.journeys": "Journeys",
    "marketing.templates": "Templates",
    "marketing.lifecycle": "Lifecycle",
    "marketing.reports": "Rapports",
    "marketing.webhooks": "Webhooks",
    "social": "Social",
    "social.inbox": "Boîte de réception",
    "social.channels": "Channels",
    "social.publishing": "Publishing",
    "social.calendar": "Calendrier",
    "social.media": "Media",
    "social.analytics": "Analytique",
    "social.automation": "Automation",
    "social.crm-leads": "CRM Leads",
    "social.teams": "Teams",
    "social.comments": "Comments",
    "social.connect": "Connect",
    "social.settings": "Paramètres",
    "social.platforms": "Platforms",
    "social.approvals": "Approbations",
    "social.webhooks": "Webhooks",
    "social.listening": "Listeening",
    "social.campaigns": "Campagnes",
    "social.reviews": "Reviews",
    "social.reports": "Rapports",
    "social.setup": "Configuration",
    "hr.employees": "Employés directory",
    "hr.devices": "Biometric devices",
    "hr.leave-policies": "Congés Politiques",
    "hr.shifts": "Équipes",
    "hr.overtime": "Heures supplémentaires requests",
    "hr.compensation": "Salary et benefits",
    "hr.statutory": "Statutory filing",
    "hr.claims": "Dépenses claims",
    "hr.travel": "Travel requests",
    "hr.reports": "RH Analytique et Tableau de bords",
    "hr.workflows": "Flux de travails",
    "hr.recruitment": "Recrutement",
    "hr.onboarding": "Intégration",
    "hr.documents": "Documents",
    "hr.succession": "Succession",
    "hr.admin": "Admin",
    "hr.training": "Formation",
    "hr.appraisal": "Appraisal",
    "hr.feedback360": "Feedback360",
    "hr.holidays": "Holidays",
    "hr.loans": "Prêts",
    "hr.asset-requests": "Asset Requests",
    "desk": "Service client",
    "desk.tickets": "Tickets",
    "desk.support-360": "Support 360",
    "desk.inbox": "Boîte de réception",
    "desk.livechat": "Livechat",
    "desk.projects": "Projets",
    "desk.boards": "Boards",
    "desk.knowledgebase": "Knowledgebase",
    "desk.reports": "Rapports",
    "desk.automation": "Automation",
    "desk.setup": "Configuration",
    "desk.setup.workflows": "Flux de travails",
    "desk.canned-responses": "Canned Responses",
    "finance": "Finance",
    "finance.receivables": "Receivables",
    "finance.payables": "Payables",
    "finance.payables.ap": "Ap",
    "finance.tax": "Tax",
    "finance.control": "Control",
    "finance.setup.wizard": "Wizard",
    "finance.health": "Health",
    "finance.close": "Close",
    "finance.control.rules": "Rules",
    "finance.treasury.forecast": "Forecast",
    "finance.collections": "Collections",
    "finance.automation": "Automation",
    "finance.analytics": "Analytique",
    "finance.compliance": "Compliance",
    "finance.audit": "Audit",
    "finance.documents": "Documents",
    "finance.integrations": "Integrations",
    "finance.accounting": "Accounting",
    "finance.ledger": "Ledger",
    "finance.invoices": "Factures",
    "finance.payments": "Payments",
    "finance.banking": "Banque",
    "finance.taxes": "Taxes",
    "finance.expenses": "Dépenses",
    "finance.assets": "Assets",
    "finance.budgets": "Budgets",
    "finance.treasury": "Treasury",
    "finance.revenue": "Revenue",
    "finance.workflows": "Flux de travails",
    "finance.workflows.designer": "Designer",
    "finance.reports": "Rapports",
    "finance.reports.builder": "Concepteur",
    "finance.setup": "Configuration",
    "projects": "Projets",
    "projects.list": "Liste",
    "projects.tasks": "Tâches",
    "projects.boards": "Boards",
    "projects.sprints": "Sprints",
    "projects.timesheets": "Timesheets",
    "projects.portfolio": "Portfolio",
    "projects.issues": "Issues",
    "projects.gantt": "Gantt",
    "projects.resources": "Resources",
    "projects.calendar": "Calendrier",
    "projects.workload": "Workload",
    "projects.reports": "Rapports",
    "projects.automation": "Automation",
    "projects.setup": "Configuration",
    "hr.org": "Rapportsing hierarchy",
    "pos.administration": "Administration",
    "pos.profile": "Profil",
    "pos.organization": "Organization",
    "pos.companies": "Sociétés",
    "pos.users": "Utilisateurs",
    "pos.roles": "Rôles",
    "pos.subscription": "Abonnement",
    "pos.settings": "Paramètres",
    "pos.work": "Travail",
    "pos.work.executive": "Executive",
    "pos.approvals": "Approbations",
    "pos.approvals.builder": "Concepteur",
    "pos.approvals.matrix": "Matrix",
    "pos.approvals.delegations": "Délégations",
    "pos.notifications": "Notifications",
    "crm.administration": "Administration",
    "crm.profile": "Profil",
    "crm.organization": "Organization",
    "crm.users": "Utilisateurs",
    "crm.roles": "Rôles",
    "crm.subscription": "Abonnement",
    "crm.settings": "Paramètres",
    "crm.work": "Travail",
    "crm.work.executive": "Executive",
    "crm.approvals": "Approbations",
    "crm.approvals.builder": "Concepteur",
    "crm.approvals.matrix": "Matrix",
    "crm.approvals.delegations": "Délégations",
    "crm.notifications": "Notifications",
    "hr.administration": "Administration",
    "hr.profile": "Profil",
    "hr.organization": "Organization",
    "hr.companies": "Sociétés",
    "hr.users": "Utilisateurs",
    "hr.roles": "Rôles",
    "hr.subscription": "Abonnement",
    "hr.settings": "Paramètres",
    "hr.work": "Travail",
    "hr.work.executive": "Executive",
    "hr.approvals": "Approbations",
    "hr.approvals.builder": "Concepteur",
    "hr.approvals.matrix": "Matrix",
    "hr.approvals.delegations": "Délégations",
    "hr.notifications": "Notifications",
    "desk.administration": "Administration",
    "desk.profile": "Profil",
    "desk.organization": "Organization",
    "desk.companies": "Sociétés",
    "desk.users": "Utilisateurs",
    "desk.roles": "Rôles",
    "desk.subscription": "Abonnement",
    "desk.settings": "Paramètres",
    "desk.work": "Travail",
    "desk.work.executive": "Executive",
    "desk.approvals": "Approbations",
    "desk.approvals.builder": "Concepteur",
    "desk.approvals.matrix": "Matrix",
    "desk.approvals.delegations": "Délégations",
    "desk.notifications": "Notifications",
    "finance.administration": "Administration",
    "finance.profile": "Profil",
    "finance.organization": "Organization",
    "finance.companies": "Sociétés",
    "finance.users": "Utilisateurs",
    "finance.roles": "Rôles",
    "finance.subscription": "Abonnement",
    "finance.settings": "Paramètres",
    "finance.work": "Travail",
    "finance.work.executive": "Executive",
    "finance.approvals": "Approbations",
    "finance.approvals.builder": "Concepteur",
    "finance.approvals.matrix": "Matrix",
    "finance.approvals.delegations": "Délégations",
    "finance.notifications": "Notifications",
    "projects.administration": "Administration",
    "projects.profile": "Profil",
    "projects.organization": "Organization",
    "projects.companies": "Sociétés",
    "projects.users": "Utilisateurs",
    "projects.roles": "Rôles",
    "projects.subscription": "Abonnement",
    "projects.settings": "Paramètres",
    "projects.work": "Travail",
    "projects.work.executive": "Executive",
    "projects.approvals": "Approbations",
    "projects.approvals.builder": "Concepteur",
    "projects.approvals.matrix": "Matrix",
    "projects.approvals.delegations": "Délégations",
    "projects.notifications": "Notifications",
    "procurement.administration": "Administration",
    "procurement.profile": "Profil",
    "procurement.organization": "Organization",
    "procurement.companies": "Sociétés",
    "procurement.users": "Utilisateurs",
    "procurement.roles": "Rôles",
    "procurement.subscription": "Abonnement",
    "procurement.settings": "Paramètres",
    "procurement.work": "Travail",
    "procurement.work.executive": "Executive",
    "procurement.approvals.builder": "Concepteur",
    "procurement.approvals.matrix": "Matrix",
    "procurement.approvals.delegations": "Délégations",
    "procurement.notifications": "Notifications",
    "warehouse.administration": "Administration",
    "warehouse.profile": "Profil",
    "warehouse.organization": "Organization",
    "warehouse.companies": "Sociétés",
    "warehouse.users": "Utilisateurs",
    "warehouse.roles": "Rôles",
    "warehouse.subscription": "Abonnement",
    "warehouse.settings": "Paramètres",
    "warehouse.work": "Travail",
    "warehouse.work.executive": "Executive",
    "warehouse.approvals": "Approbations",
    "warehouse.approvals.builder": "Concepteur",
    "warehouse.approvals.matrix": "Matrix",
    "warehouse.approvals.delegations": "Délégations",
    "warehouse.notifications": "Notifications",
    "social.administration": "Administration",
    "social.profile": "Profil",
    "social.organization": "Organization",
    "social.companies": "Sociétés",
    "social.users": "Utilisateurs",
    "social.roles": "Rôles",
    "social.subscription": "Abonnement",
    "social.work": "Travail",
    "social.work.executive": "Executive",
    "social.approvals.builder": "Concepteur",
    "social.approvals.matrix": "Matrix",
    "social.approvals.delegations": "Délégations",
    "social.notifications": "Notifications",
    "lead-gen.administration": "Administration",
    "lead-gen.profile": "Profil",
    "lead-gen.organization": "Organization",
    "lead-gen.companies": "Sociétés",
    "lead-gen.users": "Utilisateurs",
    "lead-gen.roles": "Rôles",
    "lead-gen.subscription": "Abonnement",
    "lead-gen.settings": "Paramètres",
    "lead-gen.work": "Travail",
    "lead-gen.work.executive": "Executive",
    "lead-gen.approvals": "Approbations",
    "lead-gen.approvals.builder": "Concepteur",
    "lead-gen.approvals.matrix": "Matrix",
    "lead-gen.approvals.delegations": "Délégations",
    "lead-gen.notifications": "Notifications",
    "marketing.administration": "Administration",
    "marketing.profile": "Profil",
    "marketing.organization": "Organization",
    "marketing.companies": "Sociétés",
    "marketing.users": "Utilisateurs",
    "marketing.roles": "Rôles",
    "marketing.subscription": "Abonnement",
    "marketing.settings": "Paramètres",
    "marketing.work": "Travail",
    "marketing.work.executive": "Executive",
    "marketing.approvals": "Approbations",
    "marketing.approvals.builder": "Concepteur",
    "marketing.approvals.matrix": "Matrix",
    "marketing.approvals.delegations": "Délégations",
    "marketing.notifications": "Notifications",
    "desk.customers": "Clients",
    "marketing.customers": "Clients",
    "projects.customers": "Clients",
    "lead-gen.customers": "Clients",
    "crm.customers": "Clients",
    "procurement.suppliers": "Fournisseurs",
    "procurement.products": "Produits",
    "procurement.inventory": "Inventaire",
    "procurement.inventory.ledger": "Ledger",
    "settings": "Paramètres",
    "settings.organization": "Organization",
    "settings.organization.organization-profile": "Organization Profile",
    "settings.organization.companies": "Sociétés",
    "settings.organization.users": "Utilisateurs",
    "settings.organization.roles": "Rôles et Screen Access",
    "settings.organization.subscription": "Abonnement",
    "settings.organization.stores": "Magasins",
    "settings.organization.translations": "Translations",
    "marketing.channels": "Channels",
    "marketing.calendar": "Calendrier",
    "marketing.acquisition": "Acquisition",
    "marketing.media": "Media",
    "marketing.copilot": "Copilot",
    "marketing.suppression": "Suppression",
    "social.messenger": "Messenger",
    "social.workflows": "Flux de travails",
    "social.connect.add": "Add",
    "social.setup-guide": "Configuration Guide",
    "social.executive": "Executive",
    "social.platforms.facebook": "Facebook",
    "social.platforms.instagram": "Instagram",
    "social.platforms.whatsapp": "Whatsapp",
    "social.platforms.linkedin": "Linkedin",
    "social.platforms.x": "X",
    "social.platforms.youtube": "Youtube",
    "social.platforms.google_business": "Google_business",
    "social.platforms.telegram": "Telegram",
    "social.platforms.threads": "TRHeads",
    "social.platforms.pinterest": "Pinterest",
    "social.platforms.tiktok": "Tiktok",
    "projects.:id": ":id",
    "pos.employees": "Employés",
    "crm.employees": "Employés",
    "desk.employees": "Employés",
    "finance.employees": "Employés",
    "projects.employees": "Employés",
    "procurement.employees": "Employés",
    "warehouse.employees": "Employés",
    "social.employees": "Employés",
    "lead-gen.employees": "Employés",
    "marketing.employees": "Employés",
    "settings.hr-master-data": "RH Données de référence",
    "settings.hr": "Ressources humaines",
    "settings.finance": "Finance",
    "settings.inventory": "Inventaire et PDV",
    "settings.crm": "Ventes et CRM",
    "settings.marketing": "Marketing",
    "settings.projects": "Projets",
    "settings.help-desk": "Help Service client",
    "settings.communication": "Communication",
    "settings.workflow": "Flux de travail",
    "settings.approvals": "Approbations",
    "settings.notifications": "Notifications",
    "settings.developer": "Developer",
    "settings.hr.hr-setup": "RH Configuration",
    "settings.hr.org-structure": "Rapportsing Hierarchy",
    "settings.hr.hr-admin": "RH Administration",
    "settings.finance.finance-control": "Administration Home",
    "settings.finance.health-center": "Health Center",
    "settings.finance.period-close": "Period Close",
    "settings.finance.automation-center": "Automation Center",
    "settings.finance.integration-health": "Integration Health",
    "settings.finance.accounting-advanced": "Accounting (Advanced)",
    "settings.finance.finance-setup": "Finance Configuration",
    "settings.finance.taxes": "Tax Codes",
    "settings.finance.business-rules": "Business Rules",
    "settings.finance.ledger": "General Ledger",
    "settings.finance.audit": "Finance Audit Trail",
    "settings.finance.workflows": "Finance Flux de travails",
    "settings.inventory.products": "Produits",
    "settings.inventory.categories": "Catégories",
    "settings.inventory.brands": "Marques",
    "settings.inventory.units": "Units",
    "settings.inventory.tax-rules": "Tax Rules",
    "settings.inventory.store-products": "Magasins Produits",
    "settings.inventory.discounts": "Remises",
    "settings.inventory.stock": "Stock Paramètres",
    "settings.inventory.stock-ledger": "Stock Ledger",
    "settings.inventory.warehouses": "Entrepôts",
    "settings.crm.crm-setup": "CRM Configuration",
    "settings.crm.lead-sources": "Lead Sources",
    "settings.crm.contacts": "Contacts",
    "settings.crm.crm-companies": "CRM Sociétés",
    "settings.crm.customers": "Clients",
    "settings.marketing.templates": "Marketing Templates",
    "settings.marketing.segments": "Audience Segments",
    "settings.marketing.suppression": "Consent et Suppression",
    "settings.marketing.webhooks": "Marketing Webhooks",
    "settings.marketing.acquisition": "Forms et Landing Pages",
    "settings.projects.project-setup": "Projets Configuration",
    "settings.projects.boards": "Boards",
    "settings.projects.issues": "Issues",
    "settings.projects.resources": "Resources",
    "settings.projects.automation": "Projets Automation",
    "settings.help-desk.desk-setup": "Service client Configuration",
    "settings.help-desk.workflows": "Service client Flux de travails",
    "settings.help-desk.canned-responses": "Canned Responses",
    "settings.help-desk.knowledge-base": "Knowledge Base",
    "settings.help-desk.boards": "Service client Boards",
    "settings.communication.social-connect": "Connection Center",
    "settings.communication.social-settings": "Social Paramètres",
    "settings.communication.social-webhooks": "Social Webhooks",
    "settings.workflow.finance-workflows": "Finance Flux de travail Concepteur",
    "settings.workflow.desk-workflows": "Service client Flux de travail Concepteur",
    "settings.workflow.project-automation": "Projets Flux de travail Automation",
    "settings.approvals.approval-builder": "Approbation Concepteur",
    "settings.approvals.approval-matrix": "Approbation Matrix",
    "settings.approvals.delegations": "Approbation Délégations",
    "settings.notifications.notification-center": "Notifications Center",
    "settings.developer.api-keys": "API Keys",
    "settings.developer.lead-webhooks": "Lead Webhooks",
    "settings.developer.marketing-webhooks": "Marketing Webhooks",
    "settings.hr-master-data.leave-types": "Congés types",
    "settings.hr-master-data.employment-types": "Employment types",
    "settings.hr-master-data.document-types": "Documents types",
    "settings.hr-master-data.business-units": "Business units",
    "settings.hr-master-data.departments": "Départements",
    "settings.hr-master-data.grades": "Grades",
    "settings.hr-master-data.designations": "Fonctions",
    "settings.hr-master-data.overtime-types": "Heures supplémentaires types",
    "settings.hr-master-data.shift-types": "Équipes types",
    "settings.hr-master-data.shift-definitions": "Équipes definitions",
    "settings.hr-master-data.expense-types": "Dépenses types",
    "settings.hr-master-data.asset-types": "Asset types",
    "settings.hr-master-data.asset-requests": "Asset requests",
    "settings.hr-master-data.pipeline-stages": "Pipeline stages",
    "settings.hr-master-data.holiday-calendar": "Holiday Calendrier",
    "settings.hr-master-data.holiday-types": "Holiday types",
    "settings.hr-master-data.biometric-devices": "Biometric devices"
  },
  "modules": {
    "POS": "Point de vente",
    "HR": "Ressources humaines",
    "FINANCE": "Finances",
    "CRM": "CRM",
    "DESK": "Service client",
    "PROCUREMENT": "Achats",
    "WAREHOUSE": "Entrepôt",
    "PROJECTS": "Projets",
    "SOCIAL": "Social Media",
    "MARKETING": "Marketing",
    "LEADGEN": "Génération de leads"
  },
  "breadcrumbModules": {
    "POS": "PDV",
    "CRM": "CRM",
    "HR": "RH",
    "FINANCE": "Finance",
    "DESK": "Service client",
    "PROJECTS": "Projets",
    "PROCUREMENT": "Achats",
    "WAREHOUSE": "Entrepôt",
    "SOCIAL": "Social",
    "MARKETING": "Marketing",
    "LEADGEN": "Génération de leads"
  },
  "work": {
    "myWork": "Mon travail",
    "approvalInbox": "Boîte d'approbation",
    "delegations": "Délégations d'approbation",
    "executiveView": "Vue exécutive",
    "approvalWorkflows": "Flux d'approbation",
    "workflowBuilder": "Concepteur de flux",
    "approvalMatrix": "Matrice d'approbation"
  },
  "sidebar": {
    "favorites": "Favoris",
    "recent": "Récents"
  }
}
